"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionsViewModel = questionsViewModel;
exports.visibleQuestions = visibleQuestions;
const question_1 = require("./question");
const rounds_1 = require("./rounds");
function questionsViewModel(questions) {
    return {
        questions: questions.map(question_1.questionViewModel),
        total: questions.length,
    };
}
/**
 * In a runoff, questions on which the remaining candidates do not differ carry no information: every advancing candidate answered
 * the same way, or none of them answered. Those questions are hidden from the voter and excluded from matching.
 */
function visibleQuestions({ questions, candidates, candidatesAnswers, currentRound, }) {
    if (currentRound <= 1)
        return questions;
    // Until the data says who went through (`rounds` or `elected` on a candidate), the calculator stays as it was.
    if (!candidates.some((candidate) => candidate.rounds || candidate.elected))
        return questions;
    const remaining = candidates.filter((candidate) => (0, rounds_1.candidateRoundStatus)(candidate, currentRound) === "active");
    if (remaining.length === 0)
        return questions;
    const contested = questions.filter((question) => {
        const positions = new Set();
        for (const candidate of remaining) {
            const answer = candidatesAnswers[candidate.id]?.find((candidateAnswer) => candidateAnswer.questionId === question.id)?.answer;
            positions.add(answer === true || answer === false ? answer : "skipped");
        }
        return positions.size > 1;
    });
    // Candidates who agree on everything still deserve a calculator: fall back to the whole set rather than an empty flow.
    return contested.length > 0 ? contested : questions;
}
